import { userService } from '@saucelabs/sl-util-axios';

export const getUser = (id) => (
  userService.get(`/v1/users/${id}/`)
);

export const getAccessKey = (id) => (
  userService.get(`/v1/users/${id}/access-key/`)
);

export const sendResetPasswordEmail = (id) => (
  userService.post(`/v1/users/${id}/reset-password/`)
);

export const changeEmail = ({ userId, ...data }) => (
  userService.post(`/v1/users/${userId}/change-email/`, data)
);

export const changePassword = ({ userId, ...data }) => (
  userService.put(`/v1/users/${userId}/password/`, data)
);

export const changeAssignedTeams = ({ userId, ...payload }) => (
  userService.put(`/v1/users/${userId}/teams/`, payload)
);
